package team.platforma.multiplatform_material_extension.calendar.calendar_regular.dialog

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.mel_select_date
import materialextension.multiplatform_material_extension.generated.resources.mel_select_date_period
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import team.platforma.multiplatform_material_extension.calendar.calendar_regular.core_ui.CalendarRegularImpl
import team.platforma.multiplatform_material_extension.calendar.properties.CalendarViewProperties
import team.platforma.multiplatform_material_extension.calendar.properties.DatePikerProperties
import team.platforma.multiplatform_material_extension.calendar.style.CalendarViewStyle
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.getAllDatesInMonth
import team.platforma.multiplatform_material_extension.calendar.utils.setStandardCalendarRange
import team.platforma.multiplatform_material_extension.ui.dialog.CommonDialog
import team.platforma.multiplatform_material_extension.ui.dialog.style.CommonDialogStyle
import team.platforma.multiplatform_material_extension.util.gestures.horizontalGestures
import team.platforma.multiplatform_material_extension.util.gestures.rememberHorizontalGestures

@Composable
fun DatePiker(
    value: LocalDate? = null,
    onDateSelected: (LocalDate) -> Unit,
    title: StringResource,
    calendarRange: CalendarRange? = null,
    onMonthSelected: (List<LocalDate>) -> Unit = {},
    onDismiss: () -> Unit,
    properties: DatePikerProperties? = null
) {

    val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val initializeCalendarRange = calendarRange ?: setStandardCalendarRange(currentDate)

    val initDate: LocalDate = value?.let { customStartDate ->
        if (customStartDate in initializeCalendarRange.max..initializeCalendarRange.min) {
            customStartDate
        } else {
            initializeCalendarRange.min
        }
    } ?: if (currentDate in initializeCalendarRange.max..initializeCalendarRange.min) {
        currentDate
    } else {
        initializeCalendarRange.min
    }

    var selectedDate by remember { mutableStateOf(initDate) }


    LaunchedEffect(Unit) {
        val allDatesInMonth: List<LocalDate> =
            getAllDatesInMonth(selectedDate.year, selectedDate.monthNumber)
        onMonthSelected(allDatesInMonth)
    }

    val dialogProperties: DatePikerProperties = properties ?: DatePikerProperties()
    val horizontalGestures =
        if (dialogProperties.animateUserScroll) rememberHorizontalGestures() else null

    CommonDialog(
        onDismiss = { onDismiss() },
        title = {
            Text(
                text = stringResource(title),
                modifier = Modifier.padding(vertical = 8.dp),
                fontWeight = FontWeight.Medium,
                color = CommonDialogStyle.dialogStyle().titleColor
            )
        },
        properties = DialogProperties(
            dismissOnBackPress = dialogProperties.dismissOnBackPress,
            dismissOnClickOutside = dialogProperties.dismissOnClickOutside,
            usePlatformDefaultWidth = false
        ),
        customStyle = CalendarViewStyle.pikerStyle().dialogStyle
    ) {
        LazyColumn {
            item {
                CalendarRegularImpl(
                    modifier = Modifier
                        .horizontalGestures(horizontalGestures),
                    currentDate = selectedDate,
                    onDateSelected = { localDate ->
                        selectedDate = localDate
                    },
                    calendarRange = initializeCalendarRange,
                    calendarBadges = null,
                    onMonthChange = { localDate ->
                        val allDatesInMonth: List<LocalDate> =
                            getAllDatesInMonth(localDate.year, localDate.monthNumber)
                        onMonthSelected(allDatesInMonth)
                    },
                    horizontalGestures = horizontalGestures,
                    properties = CalendarViewProperties(
                        animateClickChangeButtonMonth = dialogProperties.animateClickChangeButtonMonth,
                    ),
                    currentYear = initDate.year,
                    currentMonth = initDate.monthNumber,
                    customStyle = CalendarViewStyle.pikerStyle().dialogStyle
                )
            }
            item {

                Row(
                    modifier = Modifier.fillMaxWidth()
                        .padding(start = 8.dp, end = 8.dp, bottom = 8.dp),
                    horizontalArrangement = Arrangement.End
                ) {
                    TextButton(onClick = { onDismiss() }) {
                        Text(
                            text = stringResource(CalendarViewStyle.pikerStyle().negativeButton.label),
                            color = CalendarViewStyle.pikerStyle().negativeButton.color,
                            style = CalendarViewStyle.pikerStyle().negativeButton.style
                        )
                    }

                    TextButton(
                        onClick = {
                            onDateSelected(selectedDate)
                            onDismiss()
                        }
                    ) {
                        Text(
                            text = stringResource(CalendarViewStyle.pikerStyle().positiveButton.label),
                            color = CalendarViewStyle.pikerStyle().positiveButton.color,
                            style = CalendarViewStyle.pikerStyle().positiveButton.style
                        )
                    }
                }
            }
        }
    }
}